package com.eladfinish.bible.contest.screens.settings.ui.preferences

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.MenuAnchorType
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import dev.icerock.moko.resources.compose.colorResource
import kotlinx.collections.immutable.ImmutableList

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DropdownPreference(
    title: String,
    key: String,
    enabled: Boolean = true,
    entries: ImmutableList<String>, // Displayed text
    entryValues: ImmutableList<String>, // Stored values
    onClick: (newValue: String) -> Unit = {},
    settings: KeyValueSettings,
) {
    require(entries.size == entryValues.size) { "entries and entryValues must have the same size" }

    val frameColor = colorResource(SharedRes.colors.colorAccent)

    var expanded by rememberSaveable { mutableStateOf(false) }
    // TODO: consider changing how the default value is determined
    var selectedValue by remember { mutableStateOf(settings.getString(key, entryValues.first())) }
    val selectedIndex = entryValues.indexOf(selectedValue).takeIf { it != -1 } ?: 0
    val selectedText = entries[selectedIndex]

    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = {
            if (enabled) {
                expanded = it
            }
        }
    ) {
        OutlinedTextField(
            value = selectedText,
            onValueChange = {},
            readOnly = true,
            modifier = Modifier
                .menuAnchor(
                    type = MenuAnchorType.PrimaryNotEditable,
                    enabled = true
                )
                .fillMaxWidth()
                .wrapContentHeight(),
            enabled = enabled,
            label = {
                Text(
                    text = title,
                )
            },
            trailingIcon = { ExposedDropdownMenuDefaults.TrailingIcon(expanded = expanded) },
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = frameColor, // Frame color when focused
                unfocusedBorderColor = frameColor.copy(alpha = 0.6f) // Frame color when not focused
            ),
        )

        ExposedDropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            entries.forEachIndexed { index, entry ->
                DropdownMenuItem(
                    text = {
                        Text(
                            text = entry,
                        )
                    },
                    onClick = {
                        val newValue = entryValues[index]
                        if (newValue != selectedValue) {
                            selectedValue = newValue
                            settings.putString(key, newValue)
                            onClick(newValue)
                        }
                        expanded = false
                    },
                )
            }
        }
    }
}
